import { render, staticRenderFns } from "./roundtableRoomTwo.vue?vue&type=template&id=4b6b349e"
import script from "./roundtableRoomTwo.vue?vue&type=script&lang=js"
export * from "./roundtableRoomTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports